// Userのプロパティ.
export interface User {
  created_at?: string;
  functional_latest_date?: string;
  institution_sub?: string;
  updated_at?: string;
  user_birth_year?: string;
  user_birth_month?: string;
  user_birth_day?: string;
  user_care_id?: string;
  user_care_level?: string;
  user_gender?: number;
  user_id: string;
  user_name: string;
  user_name_kana?: string;
  medical_org?: string;
  user_visit_day?: number[];
}

interface InterfaceModel {
  id: string;
  name: string;
}

// 利用者一覧用モデル.
export const DefaultFieldModel: InterfaceModel = {
  'id': 'ID',
  'name': '名前'
};

export const patientHeader = {
  'id': 'ダウンロード',
  'name': 'ユーザID',
  'birthdayYmd': '生年月日',
  'gender': '性別',
  // 'hospitalIds': '所属医療機関ID一覧',
};

export const hospitalHeader = {
  'id': 'システムID',
  'name': '名前',
  'createdAt': '作成日'
};

export const doctorHeader = {
  'id': 'システムID',
  'name': '医師ID',
  'createdAt': '作成日'
};

export const Male: string = '男';
export const Female: string = '女';

export const TypeTraining: number = 1;
// 日常生活動作: 2?
export const TypeKiroku: number = 3;

export const MO: string = 'Mo';
export const TU: string = 'Tu';
export const WE: string = 'We';
export const TH: string = 'Th';
export const FR: string = 'Fr';
export const SA: string = 'Sa';
export const SU: string = 'Su';
export const ALL: string = 'All';

// 曜日.
export const WEEK_CHARS: string[] = [SU, MO, TU, WE, TH, FR, SA];

// 月曜日開始日曜日終わりの曜日達.
export const START_MO_WEEK_CHARS: string[] = [MO, TU, WE, TH, FR, SA, SU];



// WEBPACK FOOTER //
// ./src/constants/UserListField.tsx